import OverlayBackground from '../common/overlay/OverlayBackground'

interface ITypeCheckOverlayProps {
  onStartTest: () => void
}

const TypeCheckOverlay = ({ onStartTest }: ITypeCheckOverlayProps) => {
  return (
    <OverlayBackground>
      <div className='bg-white/90 p-8 rounded-2xl text-center max-w-xs w-full shadow-lg border border-amber-200'>
        <h2 className='text-xl font-bold text-amber-900 mb-6 leading-relaxed'>
          여정을 시작하기에 앞서
          <br />
          타입 검사가 필요해요!
        </h2>
        <button
          onClick={onStartTest}
          className='bg-gradient-to-r from-amber-400 to-amber-600 hover:from-amber-500 hover:to-amber-700 text-white font-semibold py-3 px-10 rounded-lg shadow-md transition-colors duration-150 text-md w-full'
        >
          타입 검사
        </button>
      </div>
    </OverlayBackground>
  )
}

export default TypeCheckOverlay
